import React, { Fragment, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import circleDeclined from 'assets/icons/circle-declined.svg';

import style from './style.scss';

const PendingPage = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get('key')) {
      navigate(`/applications/${params.workflowtype}/application`);
    }
  }, [window.location.search]);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-message'])}>
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">
            <div className="cell small-12 large-8 large-offset-2">
              <img src={circleDeclined} alt="Circle Declined" />
              <h2>APPLICATION PENDING</h2>
              <p>You are pre-approved, but we need more information before we can move forward. Please call us at (888) 502-8027.</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default PendingPage;
